import { render, staticRenderFns } from "./LocatorLogixLogoWhite.vue?vue&type=template&id=d0419d24&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports